var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resume"},[_c('Hero',{attrs:{"image":true}}),_c('Bio'),_c('ResumeList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }